import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { LogOut } from "Shared/appIcons";
import { UserIdentity } from "Shared/Layouts/components/UserIdentity";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type Props = {
	userLogin: string;
	userName: string;
	tenantName: string;
	userInitials: string;
	onSignOut: () => void;
};

export const UserMenu = ({
	userLogin,
	userName,
	tenantName,
	userInitials,
	onSignOut,
}: Props) => {
	const { t } = useResource();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				className="hover:bg-muted flex cursor-pointer items-center gap-2 rounded-lg py-1 pr-1 pl-2 outline-none"
				aria-label={tenantName ? `${userName} · ${tenantName}` : userName}
			>
				{/* Two-line identity (name over tenant), matching the prototype.
				    Shown from xl up; below that only the avatar remains. */}
				<UserIdentity
					initials={userInitials}
					name={userName}
					tenantName={tenantName}
					size="sm"
					hideTextBelow="xl"
					textClassName="max-w-[160px] text-left"
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" sideOffset={6} className="min-w-52">
				<DropdownMenuGroup>
					<DropdownMenuLabel className="flex flex-col gap-0.5">
						<span className="text-foreground truncate font-medium">
							{userName}
						</span>
						{tenantName ? (
							<span className="text-muted-foreground truncate text-fine font-normal">
								{tenantName}
							</span>
						) : null}
						<span className="text-muted-foreground truncate text-fine font-normal">
							{userLogin}
						</span>
					</DropdownMenuLabel>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={onSignOut}>
					<LogOut className="h-4 w-4" />
					{t(Resources.Common.SignOut)}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
